import * as React from "react";
const SvgFiRrCalculatorMoney = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-calculator-money_svg__a)">
      <path
        fill="#062147"
        d="M6 9c-3.421 0-6 1.505-6 3.5v8C0 22.495 2.579 24 6 24s6-1.505 6-3.5v-8C12 10.505 9.421 9 6 9m4 7.5c0 .529-1.519 1.5-4 1.5s-4-.971-4-1.5v-1.348c1.046.533 2.435.848 4 .848s2.954-.315 4-.848zM6 11c2.481 0 4 .971 4 1.5S8.481 14 6 14s-4-.971-4-1.5S3.519 11 6 11m0 11c-2.481 0-4-.971-4-1.5v-1.348c1.046.533 2.435.848 4 .848s2.954-.315 4-.848V20.5c0 .529-1.519 1.5-4 1.5M24 5v14c0 2.757-2.243 5-5 5h-5a1 1 0 1 1 0-2h5c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3H9C7.346 2 6 3.346 6 5v1a1 1 0 1 1-2 0V5c0-2.757 2.243-5 5-5h10c2.757 0 5 2.243 5 5m-11 5a1 1 0 1 1 0-2h5V6h-8v.5a1 1 0 1 1-2 0V6c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2zm1 8a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1m0-4v-1a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0m6 0a1 1 0 1 1-2 0v-1a1 1 0 1 1 2 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-calculator-money_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCalculatorMoney;
